import { StringType } from '@hb/map-convert';
import { convertPointString } from '../../utils/transform';
/**
 * 入参转换
 */
export var queryType = {
    location: StringType(convertPointString),
    keywords: StringType(),
    types: StringType(),
    city: StringType(),
    radius: StringType(),
    sortrule: StringType(),
    offset: StringType(),
    page: StringType(),
    extensions: StringType(),
};
/**
 * 返回值转换
 */
export var dataType = {
    // TODO 返回值转换
    adcode: StringType('adCode'),
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udmVydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL2FtYXAvcG9pQXJvdW5kU2VhcmNoL2NvbnZlcnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBRzdDLE9BQU8sRUFBRSxrQkFBa0IsRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBRTNEOztHQUVHO0FBQ0gsTUFBTSxDQUFDLElBQU0sU0FBUyxHQUFnQjtJQUNwQyxRQUFRLEVBQUUsVUFBVSxDQUFDLGtCQUFrQixDQUFDO0lBQ3hDLFFBQVEsRUFBRSxVQUFVLEVBQUU7SUFDdEIsS0FBSyxFQUFFLFVBQVUsRUFBRTtJQUNuQixJQUFJLEVBQUUsVUFBVSxFQUFFO0lBQ2xCLE1BQU0sRUFBRSxVQUFVLEVBQUU7SUFDcEIsUUFBUSxFQUFFLFVBQVUsRUFBRTtJQUN0QixNQUFNLEVBQUUsVUFBVSxFQUFFO0lBQ3BCLElBQUksRUFBRSxVQUFVLEVBQUU7SUFDbEIsVUFBVSxFQUFFLFVBQVUsRUFBRTtDQUN6QixDQUFDO0FBRUY7O0dBRUc7QUFDSCxNQUFNLENBQUMsSUFBTSxRQUFRLEdBQWdCO0lBQ25DLGFBQWE7SUFDYixNQUFNLEVBQUUsVUFBVSxDQUFDLFFBQVEsQ0FBQztDQUM3QixDQUFDIn0=